module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input type="checkbox" class="js-select" ';
 if(obj.selected) { 
__p+='checked="checked"';
 } 
__p+='><span class="label">'+
((__t=( obj.name ))==null?'':__t)+
'</span>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/groups/edit-new/templates/edit-group_item.html
// module id = 445
// module chunks = 0